<div class="container-fluid tp-box vd-host" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="cw-wrap vd-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">payment</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">Recent Payments {{ title }}</span>
				</div>
				<div class="vd-toolbar">
					<button class="btn btn-success btn-sm" (click)="exportXls()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-excel-o"></i>
					</button>
					<button class="btn btn-danger btn-sm" (click)="exportPdf()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-pdf-o"></i>
					</button>
				</div>
			</div>
			<div class="cw-body" *ngIf="viewing">
				<div class="table" #print_table>
					<table class="table">
						<tr>
							<th>Vendor ID</th>
							<th>Vendor Name</th>
							<th>Type</th>
							<th>Trans #</th>
							<th>Reference</th>
							<th>Date</th>
							<th>Amount</th>
							<th>Actions</th>
						</tr>
						<tr *ngFor="let v of viewing">
							<td>{{ v.supplierid }}</td>
							<td>{{ v.suppname }}</td>
							<td>{{ v.typename }}</td>
							<td>{{ v.transno }}</td>
							<td>{{ v.suppreference }}</td>
							<td>{{ v.trandate }}</td>
							<td>{{ getAmount(v) | currency }}</td>
							<td>
								<button mat-icon-button (click)="navigateToVendor(v.supplierid)" matTooltip="View Vendor" *ngIf="v.supplierid">
									<mat-icon>visibility</mat-icon>
								</button>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				title="Recent Payments"
				icon="payment"
				accent="rose"
				[value]="paymentsLoaded ? recentPayments.length : null"
				[loading]="!paymentsLoaded"
				[showView]="paymentsLoaded"
				(view)="toggleFlip(recentPayments, 'All')">
			</app-dashboard-stat-card>
		</div>
	</div>
</div>
